import React from 'react'
import { MessageChatCircle, MessageSmileCircle } from '../../Icons';
import ContactForm from './components/ContactForm';

const Contact = () => {
  return (
    <>
      {/* Banner Section */}
      <div className="flex flex-col gap-[24px] max-2xl:first-letter:px-[7.7vw] py-[64px] w-full max-w-[1600px]">
        <div className="flex flex-col">
          <span className='text-[#F02E49] font-[600]'>Get in Touch</span>
          <h2 className='text-[#101828] text-[48px] max-lg:text-[40px] max-md:text-[36px] max-sm:text-[32px] font-[600]'>
            We’d love to hear from you
          </h2>
        </div>
        <p className='text-[#475467] '>Our friendly team is always here to chat.</p>
      </div>

      {/* Contact Cards */}
      <div className="grid grid-cols-2 gap-[24px] max-2xl:first-letter:px-[7.7vw] py-[64px] max-sm:grid-cols-1 w-full max-w-[1600px]">
        <div className="bg-[#F9FAFB] flex flex-col gap-[64px] p-[24px] rounded-[10px] items-start">
          <div className="flex items-center justify-center rounded-xl p-[12px] bg-[#F02E49] w-fit">
            <MessageSmileCircle className="w-[24px] h-[24px]" />
          </div>
          <div className="flex flex-col gap-[20px]">
            <div className="flex flex-col gap-[8px]">
              <span className="text-[#101828] text-[20px] font-[600]">Contact Support</span>
              <span className="text-[#475467] text-[16px] font-[400]">Speak to our friendly team.</span>
            </div>
            <a target='_blank' href='mailto:Support@CertifiedDJ.co.uk' rel="noreferrer" className="text-[#5556C3] font-[600]"> Support@CertifiedDJ.co.uk</a>
          </div>
        </div>
        <div className="bg-[#F9FAFB] flex flex-col gap-[64px] p-[24px] rounded-[10px] items-start">
          <div className="flex items-center justify-center rounded-xl p-[12px] bg-[#F02E49] w-fit">
            <MessageChatCircle iconColor={'#fff'} className="w-[24px] h-[24px]" />
          </div>
          <div className="flex flex-col gap-[20px]">
            <div className="flex flex-col gap-[8px]">
              <span className="text-[#101828] text-[20px] font-[600]">Chat Support</span>
              <span className="text-[#475467] text-[16px] font-[400]">We are here to help.</span>
            </div>
            <a target='_blank' href='mailto:Info@CertifiedDJ.co.uk' rel="noreferrer" className="text-[#5556C3] font-[600]">Info@CertifiedDJ.co.uk</a>
          </div>
        </div>
      </div>

      {/* Contact Form Section */}
      <ContactForm />
    </>
  )
}

export default Contact;